import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../rest/authentication.service';
import { DeviceDetectionService } from '@core/services/common/device-detection.service';

export const deviceDetectionGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  const deviceDetectionService = inject(DeviceDetectionService);
  const token = await authenticationService.getJwtAccessToken();
  const redirectRoute = router.createUrlTree([deviceDetectionService.isMobile() ? '/mobile' : 'user/login']);

  return token ? true : redirectRoute;
};
